import { render, staticRenderFns } from "./HomeSpacesPanel.vue?vue&type=template&id=5c65313c&"
import script from "./HomeSpacesPanel.vue?vue&type=script&lang=js&"
export * from "./HomeSpacesPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports